/**
 * Inserts merge tag text at the beginning of the tracked merge tag range.
 *
 * @param {String} mergeTag  The merge tag text.
 * @param {Number} start     The start position of the merge tag pattern.
 * @param {Number} end       The end position of the merge tag pattern.
 *
 * @returns {Function} Parametrized command to insert a merge tag.
 *
 */
export const insertMergeTag = (mergeTag, start, end) => {

	return (state, dispatch) => {

		const { tr } = state;

		// Insert merge tag text after '{{' characters
		tr.insertText(mergeTag, start, end);
		tr.setMeta('deactivateMergeTag', true);

		if (dispatch) {
			dispatch(tr);
		}

		return true;

	};

};
